<template>
  <div class="p-grid dashboard">
    <div class="p-col-12">
      <Toast />

      <div class="card">
        <div class="title">Laporan Kelompok Barang</div>
        <DataTable
          :value="items"
          :lazy="true"
          :paginator="true"
          class="p-datatable-outlets"
          :rows="limit"
          :scrollable="true"
          :totalRecords="total_records"
          :loading="loading"
          @page="getReportCategory($event)"
        >
          <template #header>
            <div class="p-grid p-fluid p-mb-2">
              <div class="p-col-3" style="margin-top: 2.2rem">
                <router-link
                  :to="{
                    name: 'print-report-category',
                    query: { total_data: total_records }
                  }"
                  target="_self"
                >
                  <Button
                    label="Print Laporan Barang Kategori"
                    icon="pi pi-print"
                    class="p-button-info"
                  />
                </router-link>
              </div>
            </div>
          </template>
          <template #empty>Data tidak ditemukan.</template>
          <template #loading
            >Mengambil data kelompok barang. Mohon tunggu</template
          >
          <Column
            header="Kelompok Barang"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.category + ' - ' + slotProps.data.name }}
              </div>
            </template>
          </Column>
          <Column
            header="Total Barang"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.total_item | number }}
              </div>
            </template>
          </Column>
          <Column
            header="Jumlah Terjual"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.total_sell | number }}
              </div>
            </template>
          </Column>
          <Column
            header="Mutasi Masuk"
            headerStyle="text-align: center; width: 12rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.mutasi_masuk | number }}
              </div>
            </template>
          </Column>
          <Column
            header="Mutasi Keluar"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.mutasi_keluar | number }}
              </div>
            </template>
          </Column>
          <Column
            header="Stok Barang"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.stok_item | number }}
              </div>
            </template>
          </Column>
          <Column
            header="Stok Price"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.stock_price | currency }}
              </div>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </div>
</template>

<script>
var moment = require('moment')
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['user', 'isAuthenticated'])
  },
  data() {
    return {
      moment: moment,
      loading: true,
      expandedRows: [],
      items: null,
      limit: 30,
      total_records: 0
    }
  },
  mounted() {
    this.getReportCategory()
    this.getAuthUser()
  },
  methods: {
    getAuthUser() {
      console.info(this.user)
    },

    async getReportCategory(event) {
      this.loading = true
      let page = 1
      if (event) {
        page = event.page + 1
      }

      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/report_category?page=${page}&limit=${this.limit}`,
          {
            timeout: 50000
          }
        )

        if (response.status === 200) {
          this.items = response.data.data.category
          this.total_records = response.data.data.total_data
        } else {
          this.showToast('error', 'Error', 'Gagal mengambil data')
        }
      } catch (error) {
        if (error.code === 'ECONNABORTED') {
          this.showToast(
            'error',
            'Error',
            'Gagal mengambil data, request timeout'
          )
        } else {
          this.showToast('error', 'Error', 'Gagal mengambil data')
        }
      } finally {
        this.loading = false
      }
    },

    closeDialog() {
      this.confirmDialog = false
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #607d8b;
  }
}

.qty {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 50px;
}

.p-datatable .p-column-filter {
  display: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

/deep/ .p-datatable.p-datatable-outlets {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

/* Responsive */
.p-datatable-outlets .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }

  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }

  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }

  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}

.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}

@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}

.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.orders-subtable {
  padding: 1rem;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}

.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }

  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }

  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }

  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}

@media screen and (max-width: 960px) {
  /deep/ .p-datatable {
    &.p-datatable-outlets {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr {
        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          border: 0 none;

          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }

          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}
::v-deep(.p-datatable table) {
  border-collapse: collapse;
}

::v-deep(.p-datatable th),
::v-deep(.p-datatable td) {
  border: 1px solid #ccc !important;
  padding: 8px;
}
</style>
